import { render } from "./TextInput.vue?vue&type=template&id=c540e848"
import script from "./TextInput.vue?vue&type=script&lang=js"
export * from "./TextInput.vue?vue&type=script&lang=js"

import exportComponent from "C:\\laragon\\www\\pajak-system\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__